import { render, staticRenderFns } from "./NewDataSourceDialog.vue?vue&type=template&id=f461768e&scoped=true&"
import script from "./NewDataSourceDialog.vue?vue&type=script&lang=js&"
export * from "./NewDataSourceDialog.vue?vue&type=script&lang=js&"
import style0 from "./NewDataSourceDialog.vue?vue&type=style&index=0&id=f461768e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f461768e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VForm,VIcon,VRow,VSpacer,VTooltip})
